// Searches downwards for the closest valid value that exists in the allowed list
function getClosestSmallerValue(selectedValue, allowedArray, fallbackValue) {
  if (!allowedArray.length) return fallbackValue;

  // Filter for values smaller than or equal to the selected value, then take the largest one
  const validOptions = allowedArray.filter(v => v <= selectedValue);
  return validOptions.length ? Math.max(...validOptions) : Math.min(...allowedArray);
}

// Searches upwards for the closest valid value that exists in the allowed list
function getClosestLargerValue(selectedValue, allowedArray, fallbackValue) {
  if (!allowedArray.length) return fallbackValue;

  // Filter for values larger than or equal to the selected value, then take the smallest one
  const validOptions = allowedArray.filter(v => v >= selectedValue);
  return validOptions.length ? Math.min(...validOptions) : Math.max(...allowedArray);
}

function parseDataValues( $fromInput, $toInput ) {
  // Use .data('values') or .attr('data-values')
  const fromRaw = $fromInput?.attr('data-values');
  const toRaw = $toInput?.attr('data-values');

  const fromValues = fromRaw ? fromRaw.split(',').map(Number) : [];
  const toValues = toRaw ? toRaw.split(',').map(Number) : [];

  const all = new Set([...fromValues, ...toValues]);
  return Array.from(all).sort((a, b) => a - b);
}

export function initFilterSlider() {

  const rangeslider_group = $( ".rangeslider-group" );

  if ( !rangeslider_group ) return;

  const sorted_controls = {};
  const from_titles = ['från', 'from'];
  const to_titles = ['till', 'to'];

  let idxCounter = 0;
  $( ".rangeslider-filter-title" ).each(function(index, element) {

    const $element = $( element );
    const currentTextSplit = $element.text().trim().split(" ");
    const lastWord = currentTextSplit.length ? currentTextSplit[currentTextSplit.length - 1].toLowerCase() : undefined;

    if (from_titles.includes(lastWord) || to_titles.includes(lastWord)) {
      currentTextSplit.pop();
      const baseKey = currentTextSplit.join(" ");

      if (!sorted_controls[baseKey]) {
        sorted_controls[baseKey] = { index: idxCounter };
      }

      // Find the container immediately following this title
      const $rangesliderContainer = $element.next(".rangeslider");
      const $inputElement = $rangesliderContainer.find("input.js-range-slider");

      if (from_titles.includes( lastWord ) ) {
        sorted_controls[baseKey].from = $inputElement;
      } else {
        sorted_controls[baseKey].to = $inputElement;
      }

      // HIDE BOTH ELEMENTS: The title ($element) and its matching rangeslider wrapper
      $element.hide();
      $rangesliderContainer.hide();
    }
    idxCounter++;
  });

  for (const [ key, value ] of Object.entries( sorted_controls ) ) {

    if ( !value.from || !value.to ) continue;

    const values_merged = parseDataValues( value.from, value.to );
    if ( !values_merged.length ) continue;

    const existingSlider = rangeslider_group.find( `#wl-filter-slider-${value.index}` );

    if ( existingSlider.length ) {
      continue;
    }

    if (window.$ && $.fn && $.fn.ionRangeSlider) {
      const wrapper = $('<div>', {
        id: `wl-filter-slider-${value.index}`,
        class: 'wl-filter-slider wl-script-added'
      });

      const label = $('<span>', {
        class: 'wl-filter-slider__label',
        text: key
      });

      const slider_input = $( "<input>", {  });

      const rawFromValues = value.from.attr("data-values");
      const rawToValues = value.to.attr("data-values");

      const values_from = rawFromValues ? rawFromValues.split(",").map(Number) : [];
      const values_to = rawToValues ? rawToValues.split(",").map(Number) : [];

      const fromAllowed = new Set(values_from);
      const toAllowed = new Set(values_to);

      const minValue = values_merged[0];
      const maxValue = values_merged[values_merged.length - 1];

      slider_input.attr( "data-min", minValue );
      slider_input.attr( "data-max", maxValue );

      const original_index_from = parseInt(value.from.attr("data-from"), 10);
      const original_index_to = parseInt(value.to.attr("data-to"), 10);

      const from_value = (!isNaN(original_index_from) && values_from[original_index_from] !== undefined) ? values_from[original_index_from] : minValue;
      const to_value = (!isNaN(original_index_to) && values_to[original_index_to] !== undefined) ? values_to[original_index_to] : maxValue;

      let merged_from = values_merged.indexOf(from_value);
      let merged_to = values_merged.indexOf(to_value);

      if (merged_from === -1) merged_from = 0;
      if (merged_to === -1) merged_to = values_merged.length - 1;

      const valuesDisplay = $('<div>', {
        class: 'wl-filter-slider__values',
        html: `<span class="wl-filter-slider__from">${from_value}</span><span class="wl-filter-slider__to">${to_value}</span>`
      });

      wrapper.append( label, slider_input, valuesDisplay );

      slider_input.ionRangeSlider({
          type: "double",
          from: merged_from,
          to: merged_to,

          values: values_merged,

          onFinish: function (data) {
            const selectedFrom = values_merged[data.from];
            const selectedTo   = values_merged[data.to];

            // 1. Find the closest valid matches for the hidden fields
            // From falls back downwards; To falls back upwards
            const newFrom = fromAllowed.has(selectedFrom) ? selectedFrom : getClosestSmallerValue(selectedFrom, values_from, minValue);
            const newTo   = toAllowed.has(selectedTo)     ? selectedTo   : getClosestLargerValue(selectedTo, values_to, maxValue);

            // 2. Calculate parent-specific boundaries dynamically
            const parentFromMax = values_from.length > 0 ? Math.max(...values_from) : maxValue;
            const parentToMin   = values_to.length > 0 ? Math.min(...values_to) : minValue;

            // 3. Apply the valid values to the hidden inputs using jQuery .val()
            value.from.val(`${newFrom};${parentFromMax}`);
            value.to.val(`${parentToMin};${newTo}`);

            // 4. Find exact tracking indices for the original valid elements
            const originalFromIdx = values_from.indexOf(Number(newFrom));
            const originalToIdx   = values_to.indexOf(Number(newTo));

            // 5. Set tracking data attributes using jQuery .attr()
            value.from.attr("data-from", originalFromIdx !== -1 ? originalFromIdx : 0);
            value.from.attr("data-to", values_from.length > 0 ? values_from.length - 1 : 0);

            value.to.attr("data-from", 0);
            value.to.attr("data-to", originalToIdx !== -1 ? originalToIdx : (values_to.length > 0 ? values_to.length - 1 : 0));

            // 6. Update the explicit visual text nodes with what the user actually dropped on
            const fromDisplay = wrapper.find('.wl-filter-slider__from');
            const toDisplay   = wrapper.find('.wl-filter-slider__to');

            if (fromDisplay.length) fromDisplay.text(selectedFrom);
            if (toDisplay.length) toDisplay.text(selectedTo);
          }
      });

      rangeslider_group.append( wrapper );

    }
  }
}